import React, { useCallback, useEffect, useState } from 'react';
import { Page, PageNavigation } from '@ui/components';
import { getFactories, IFactory } from '@ui/api/v2/store.api';
import FactoryCard from './FactoryCard';

import './Factories.less';
import FactoryForm from './FactoryForm';

export function Factories() {
  const [factories, setFactories] = useState<IFactory[]>([]);

  const [editMarket, setEditMarket] = useState<IFactory>();

  const fetchFactories = useCallback(async () => {
    const { data } = await getFactories();
    if (data) {
      setFactories(data);
    }
  }, []);

  useEffect(() => {
    void fetchFactories();
  }, [fetchFactories]);

  const resetEditMarket = useCallback(() => {
    setEditMarket(undefined);
  }, []);

  const onMarketCreate = useCallback((market: IFactory) => {
    setFactories(m => [...m, market]);
  }, []);

  const onMarketUpdate = useCallback((market: IFactory) => {
    setFactories(markets =>
      markets.map(m => {
        if (m.id === market.id) {
          return market;
        }
        return m;
      }),
    );
  }, []);

  const onMarketDelete = useCallback((marketId: number) => {
    setFactories(markets => markets.filter(m => m.id !== marketId));
  }, []);

  return (
    <div className="markets">
      <PageNavigation title="Фабрики" />
      <Page>
        <Page.LeftSide>
          <FactoryForm
            factory={editMarket}
            onFactoryCreate={onMarketCreate}
            onFactoryUpdate={onMarketUpdate}
            resetEditFactory={resetEditMarket}
          />
        </Page.LeftSide>
        <Page.Content>
          <div className="markets__wrapper">
            {[...factories]
              .sort((a, b) => (a.name < b.name ? -1 : 1))
              .map(m => (
                <FactoryCard
                  key={m.id}
                  factory={m}
                  setEditFactory={setEditMarket}
                  onDelete={onMarketDelete}
                />
              ))}
          </div>
        </Page.Content>
      </Page>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Factories/Factories.tsx